import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Permissões", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Registro Atividades", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tela_padrao_crud = _resolveComponent("tela-padrao-crud")!
  const _component_usuario_modal = _resolveComponent("usuario-modal")!
  const _component_registro_atividades_modal = _resolveComponent("registro-atividades-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_tela_padrao_crud, {
      ref: "refCrudUsuario",
      estrutura: _ctx.crudBase.estrutura,
      servicoAPI: _ctx.servicoUsuario,
      onExibirModal: _ctx.exibirModal,
      onSincronizaTelaCrud: _ctx.sincronizaTelaCrud
    }, {
      AcoesRecursosInicio: _withCtx(() => [
        _createVNode(_component_router_link, {
          class: "ant-btn ss-btn-tela",
          to: { name: 'ControlePermissoesUsuario' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_icone, { nome: "cadeado" }),
            _hoisted_1
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ss-btn-tela",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.apresentarRegistroAtividade && _ctx.apresentarRegistroAtividade(...args)))
        }, [
          _createVNode(_component_icone, { nome: "historico" }),
          _hoisted_2
        ])
      ]),
      _: 1
    }, 8, ["estrutura", "servicoAPI", "onExibirModal", "onSincronizaTelaCrud"]),
    _createVNode(_component_usuario_modal, {
      visivel: _ctx.crudBase.exibirModal,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.crudBase.exibirModal) = $event)),
      operacao: _ctx.crudBase.operacao,
      "onUpdate:operacao": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.crudBase.operacao) = $event)),
      onSincronizarRegistro: _ctx.sincronizarRegistro
    }, null, 8, ["visivel", "operacao", "onSincronizarRegistro"]),
    _createVNode(_component_registro_atividades_modal, {
      visivel: _ctx.stateUsuario.apresentarRegistroAtividade,
      "onUpdate:visivel": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stateUsuario.apresentarRegistroAtividade) = $event))
    }, null, 8, ["visivel"])
  ], 64))
}